<script>
import options from "./CheckoutLine.options";
export default options;
</script>

<template>  
    <transition name="fade">
        <article v-show="displayItem" class="nti-checkout-line__item" data-js="basket-item" data-code="128L1-WW9193-T743_1">
            <section class="nti-checkout-line__item__wrapper">
                <div class="nti-checkout-line__item__image-container">
                    <img :src="lineData.imageUrl" alt="Image of product" />
                </div>
                <div class="nti-checkout-line__item__labels">
                    <h4 class="nti-checkout-line__item__title">
                        <a :href="lineData.url" title="Autodesk 3ds Max">{{ lineData.displayName }}</a>
                        <span></span>
                    </h4>
                    <p class="nti-checkout-line__item__disclaimer" v-if="lineData.disclaimerText">{{ lineData.disclaimerText }}</p>
                    <p>{{ lineData.description }}</p>
                </div>
            </section>

            <section class="nti-checkout-line__item__info-container">
                <div class="nti-checkout-line__item__amount nti-checkout-line__item__info-block">
                    <label for="amount-input-field" class="nti-checkout-line__item__info-block__label">{{ verifyLabel('quantityLabel') }}</label>
                    <div class="plus-minus-selector nti-configurator-tablist__plus-minus nti-configurator-tablist__plus-minus--checkout-line">
                        <button href="#" class="plus-minus-selector__btn plus-minus-selector__btn--minus" v-on:click="decrementAmount" aria-label="Subtract product"></button>
                            <input 
                                id="amount-input-field" 
                                class="nti-configurator-tablist__plus-minus__input" 
                                name="product-amount" 
                                v-model="displayQuantity" 
                                @change="changeAmount"
                                type="number">
                        <button href="#" class="plus-minus-selector__btn plus-minus-selector__btn--plus" v-on:click="incrementAmount" aria-label="Add product"></button>
                    </div>
                    <span class="nti-configurator-tablist__plus-minus__input--mini-cart">{{ displayQuantity }}</span>
                </div>

                <div class="nti-checkout-line__item__info-block nti-checkout-line__item__info-block--price nti-checkout-line__item__info-block--mini-cart">
                    <span class="nti-checkout-line__item__info-block__label">{{ verifyLabel('quantityDescriptorLabel') }}</span>
                    <div class="nti-checkout-line__item__info-block__price" :class="{ 'nti-checkout-line__item__info-block__price--old' : discountedProduct }">
                        {{ singleProductPrice }}
                    </div>
                    <div v-if="discountedProduct" class="nti-checkout-line__item__info-block__price nti-checkout-line__item__info-block__price--discount">
                        {{ singlePriceDiscount }}
                    </div>
                </div>

                <div class="nti-checkout-line__item__info-block nti-checkout-line__item__info-block--price" :class="{ 'nti-checkout-line__item__info-block--scroll-margin' : scrollbarMargin }">
                    <span class="nti-checkout-line__item__info-block__label nti-checkout-line__item__info-block__label--mini-cart">{{ verifyLabel('priceLabel') }}</span>
                    <div class="nti-checkout-line__item__info-block__price" :class="{ 'nti-checkout-line__item__info-block__price--old' : discountedProduct }">
                        {{ totalPriceDiscount }}
                    </div>
                    <div v-if="discountedProduct" class="nti-checkout-line__item__info-block__price nti-checkout-line__item__info-block__price--discount">
                        {{ totalProductPrice }}
                    </div>
                </div>
                <div class="nti-checkout-line__item__remove-container nti-checkout-line__item__info-block">
                    <button
                        type="button"
                        class="nti-button nti-button--remove-from-cart"
                        v-on:click="removeProduct"
                        aria-label="Remove product"
                        data-btn="remove">
                        <div class="nti-svg__container-medium nti-svg--remove-from-cart">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path
                                    d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
                                />
                            </svg>
                        </div>
                        <p>{{ verifyLabel('removeItem') }}</p>
                    </button>
                </div>
            </section>
        </article>
    </transition>   
</template>